import { useContextSelectors } from "@-/com.npmjs.use-context-selectors";
import { StaticDatabaseContext } from "@-/dev.improve.haniverse.contexts.database.static";
import { createUseQueryOptions } from "@-/dev.improve.haniverse.lib.query-options";
import { getHskVersionStats } from "#hsk-version-stats";

export function useGetHskVersionStatsQueryKey() {
  const [staticDb] = useContextSelectors(StaticDatabaseContext, (c) => c.db);
  return () => ["hskVersionStats", { staticDb }] as const;
}

/**
 * Per-version HSK stats for the HSK version settings page. The static DB is immutable for the
 * app's lifetime, so the key carries no change-version. Prefetched by
 * `useHskVersionSettingsPageNavigator`.
 */
export const [useHskVersionStatsQueryOptions, hskVersionStatsQueryFn] = createUseQueryOptions(
  useGetHskVersionStatsQueryKey,
  async ({ queryKey: [, { staticDb }] }) => getHskVersionStats(staticDb(import.meta.location)),
);
